import {
  HowItWorksRoot,
  Title,
  HowItWorksContainer,
  StepWrapper,
  StepImage,
  StepCopy,
  Number,
  Action,
  Description,
  StepsContainer,
  ButtonWrapper,
} from './HowItWorks.styles'
import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import { defaultSteps, Step } from './steps'
import { Stack } from 'components/Stack'
import { Button } from 'components/Button'
import Link from 'next/link'
import { TranslationKeys } from 'locales/translationKeys'

type HowItWorksProps = {
  variant?: 'primary' | 'secondary'
  steps?: Step[]
  cta?: TranslationKeys
  title?: TranslationKeys
}

export const HowItWorks = ({ variant = 'primary', steps = defaultSteps, cta = 'home:CTA', title = 'home:how-it-works.title' }: HowItWorksProps) => {
  const { t } = useTranslation()
  return (
    <HowItWorksRoot variant={variant}>
      <HowItWorksContainer>
        <Title variant={variant}>{t(title)}</Title>
        <StepsContainer>
          {steps.map(({ imageSrc, imageAlt, action, description, number }, index) => (
            <StepWrapper key={index}>
              <StepImage>
                <Image objectFit="cover" width={290} height={150} alt={t(imageAlt)} src={imageSrc} />
              </StepImage>
              <StepCopy variant={variant}>
                <Number>
                  {t(number)}
                </Number>
                <Stack direction='column' gap='0'>
                  <Action size='body' weight="semiBold">{t(action)}</Action>
                  <Description weight='regular' size='body'>{t(description)}</Description>
                </Stack>
              </StepCopy>
            </StepWrapper>
          ))}
        </StepsContainer>
        <ButtonWrapper>
          <Link passHref href='/meal-plan'>
            <Button className='cta'>
              {t(cta)}
            </Button>
          </Link>
        </ButtonWrapper>
      </HowItWorksContainer>
    </HowItWorksRoot>
  )
}
